export class QuickLinkSignFormData {

    launchUrl?: string;
    target?: string;
    method: string;
    url: string;
    params: {
        user_id: number;
        isbn: string;
        code: string;
        oauth_callback: string;
        oauth_consumer_key: string;
        oauth_nonce: string;
        oauth_signature: string;
        oauth_signature_method: string;
        oauth_timestamp: string;
        oauth_version: string;
        target: string;
        product_id: string;
        // For LTI
        id: number;
        lti_message_type: string;
        lti_version: string;
        resource_link_id: string;
        theme: string;
        roles: string;
        custom_code: string;
        context_id: string;
        custom_yedo: string;
        partner: string;
        license_type?: string;
        custom_worksheet_updated_at?: number;
        custom_worksheet_id?: string;
        custom_assignments?: string;
    };
}
